define.alias("shared/components/shared/mavely/links/folder", "calendar/components/shared/mavely/links/folder");